import service from './service';
import axios from 'axios'; // 不走二次封装，直接发起的特殊请求

export function axiosUrl(url) {
  return axios(url);
} // 获取二维码

export function getQR(data) {
  return service({
    url: 'v3/qr/web/get',
    method: 'POST',
    data: data
  });
} // 检查二维码

export function checkQR(data) {
  return service({
    url: 'v3/qr/web/check',
    method: 'post',
    data: data
  });
} // 用户登录

export function login(data, serveUrl) {
  return service({
    url: "newLogin?service=".concat(serveUrl),
    method: 'post',
    data: data
  });
}